import React, { useEffect, useState } from 'react';
import { Button, Box, Grid, Typography } from '@mui/material';

const NetworkTabs = ({ networkList, setSelectedFirm, setPage }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleTabClick = (item, index) => {
    setSelectedIndex(index);
    setSelectedFirm({
      firm_role_id: item.firm_role_id,
      firm_role_type: item.firm_role_type,
    });
    setPage(0);
  };

  useEffect(() => {
    if (networkList.length > 0 && selectedIndex === 0) {
      handleTabClick(networkList[0], 0);
    }
  }, [networkList]);
  return (
    <Grid sx={{ mb: 2 }}>
      <Typography sx={{ mb: 2, fontSize: 18, fontWeight: '700' }}>
        Select Network Type
      </Typography>
      <Box
        sx={{ display: 'flex', gap: 2, overflowX: 'auto', flexWrap: 'wrap' }}
      >
        {networkList?.map((item, index) => (
          <Button
            key={index}
            onClick={() => handleTabClick(item, index)}
            sx={{
              backgroundColor:
                selectedIndex === index ? 'primary.main' : 'grey.200',
              color: selectedIndex === index ? 'white' : 'black',
              borderRadius: 2,
              padding: '5px 10px',
              minWidth: '150px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor:
                  selectedIndex === index ? 'primary.dark' : 'grey.300',
              },
            }}
          >
            <Grid
              container
              direction='column'
              alignItems='center'
            >
              <Typography
                sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: '600' }}
              >
                {item.display_name}
              </Typography>
            </Grid>
          </Button>
        ))}
      </Box>
    </Grid>
  );
};

export default NetworkTabs;
